// Payment Component
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentInfoStyle as styles } from './paymentInfo.tailwind';
import { cartInfoStyle as cartStyles } from '../CartInfo/cartInfo.tailwind';
import { useSelector, connect } from 'react-redux';
import { checkoutPayment, checkoutPaymentCoins, getMyCart } from '../../../redux/slices/cartSlice';
import Button from '../../shared/Button/Button';
import routeConstant from '../../../lib/constants/routeConstant';
import { PAYMENT_STATUS } from '../../../lib/constants/globalConstant';
import { fetchUserPointsAndRewards } from '../../../redux/slices/rewardSlice';
import CoinsPaymentStatusModal from '../../shared/Modals/CoinsPaymentStatusModal/CoinsPaymentStatusModal';
import { setMyAccountActiveTab } from '../../../redux/slices/publicSlice';
import { MY_ACCOUNT_TABS } from '../../MyAccount/myAccountTabsData';

const TAX = process.env.REACT_APP_TAX

const PaymentDetails = ({ proceedToPayment, fetchPointsAndRewards, proceedToPaymentForTokens, setActiveTab, getCart }) => {
  const navigate = useNavigate();
  const { cartData, checkingOutPayment, checkingOutPaymentCoins } = useSelector((state) => state.cart);
  const { currentSeason } = useSelector((state) => state.seasons);

  // FOR DEMO
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);

  // handle proceed to payment function for demo application 
  // FOR DEMO
  const handleProceedToPaymentForTokens = async () => {
    const data = {
      orderId: cartData._id,
      seasonId: cartData.seasonId
    }

    // Proceed to payment - checkout
    const result = await proceedToPaymentForTokens(data);


    if (checkoutPaymentCoins.fulfilled.match(result)) {
      if (result.payload.status === true) {
        setPaymentStatus(PAYMENT_STATUS.SUCCEDED);
        // setPaymentStatusModal(true);
        // emptyCart({ seasonId: currentSeason?._id });
        fetchPointsAndRewards({
          seasonId: currentSeason?._id
        });
        setActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB);
        getCart({
          seasonId: currentSeason?._id
        });
        navigate(routeConstant.MY_ACCOUNT_PAGE, {
          state: { paymentStatus: PAYMENT_STATUS.SUCCEDED },
        });
      }
    } else {
      setPaymentStatus(PAYMENT_STATUS.FAILED);
      setActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB);
      setPaymentStatusModal(true);
    }
  }


  // handle Proceed to Payment button [Checkout Button]
  const handleProceedToPayment = async () => {
    // checkout-data
    const data = {
      orderId: cartData._id,
      seasonId: cartData.seasonId
    }

    // Proceed to payment - checkout
    const result = await proceedToPayment(data);

    // Navigate if api hits success message
    if (result.payload.status === true) {
      navigate(routeConstant.PAYMENT_PAGE);
    }
  }

  return (
    <div className={styles.outerBox}>
      {/* Heading */}
      <div className={styles.borderBottom}>
        <h2 className={styles.heading}>Summary</h2>
      </div>

      {/* Subtotal Checkout Section */}
      <div className={cartStyles.subtotal_section}>
        <div className={cartStyles.subtotal_inner_box}>
          {/* Subtotal and Shipping Section */}
          <div className={cartStyles.subtotal_shipping}>
            {/* Subtotal Item */}
            <div className={cartStyles.subtotal_shipping_item}>
              <div className={cartStyles.text}>Subtotal</div>
              {/* subtotal amount */}
              <div className={cartStyles.total_text}>{`$ ${cartData?.subTotal || "--"}`}</div>
            </div>

            {/* Shipping Item */}
            <div className={`${cartStyles.subtotal_shipping_item} ${styles.border}`}>
              <div className={cartStyles.text}>
                Taxes
                <span className='text-secondaryRed font-[400]'> ({TAX || 5}%)</span>
              </div>
              <div className={cartStyles.shipping_box}>
                <span className={cartStyles.total_text}>{`$ ${cartData?.taxes || "--"}`}</span>
              </div>
            </div>
          </div>

          {/* Total Section */}
          <div className={cartStyles.total_amount}>
            <div className={cartStyles.text}>Total</div>
            {/* total amount */}
            <div className={cartStyles.total_value_text}>{`$ ${cartData?.orderTotal || "--"}`}</div>
          </div>

          {/* Proceed to Payment */}
          <div className={cartStyles.proceed_to_pay_box}>
            {/* Onclick function needs to be changed handleProceedToPayment */}
            <Button variant="primary" className={cartStyles.proceed_to_pay} onClick={handleProceedToPaymentForTokens} disabled={checkingOutPayment}>
              {/* {checkingOutPayment ? `Proceeding...` : `Proceed to Payment`} */}
              {checkingOutPaymentCoins ? `Confirming` : `Confirm your Token Selection`}
            </Button>
          </div>
        </div>
      </div>
      {paymentStatusModal &&
        <CoinsPaymentStatusModal
          isOpen={paymentStatusModal}
          onClose={() => setPaymentStatusModal(false)}
          status={paymentStatus}
        />
      }
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  proceedToPayment: (data) => dispatch(checkoutPayment(data)),
  proceedToPaymentForTokens: (data) => dispatch(checkoutPaymentCoins(data)),
  fetchPointsAndRewards: (data) => dispatch(fetchUserPointsAndRewards(data)),
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
  getCart: (data) => dispatch(getMyCart(data)),
});

export default connect(null, mapDispatchToProps)(PaymentDetails);